import { render, staticRenderFns } from "./bottom-sheet.vue?vue&type=template&id=37417841&scoped=true&"
import script from "./bottom-sheet.vue?vue&type=script&lang=js&"
export * from "./bottom-sheet.vue?vue&type=script&lang=js&"
import style0 from "./bottom-sheet.vue?vue&type=style&index=0&id=37417841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37417841",
  null
  
)

export default component.exports